// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'b67d35ab';
